<template>
  <div>
    <custom-result-not-found
        v-if="!evaluations.length"
        text="No hay información disponible."
      />

      <template v-else>
        <student-evaluation-history-list
          :evaluations="evaluations"
          @refresh-evaluations="getHistoryList"
          read-only
        />
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          show-text
          @pagination-go-page="goToPage"
        />
      </template>
  </div>
</template>

<script>
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import { getHistory } from '@/modules/student-evaluations/api.js';
import StudentEvaluationHistoryList from '@/views/student/evaluation-history/components/StudentEvaluationHistoryList';
import evaluationSourceTypes from '@/utils/constants/student/evaluationSourceTypes';
import appointmentStatusEnum from '@/utils/constants/student/appointmentStatusEnum';

const DEFAULT_PAGE_SIZE = 10;

export default {
    name: 'StudentEvaluations',
    components: {
        CustomResultNotFound,
        Pagination,
        StudentEvaluationHistoryList
    },
    props:{
        studentSieId:{
            type: String,
            required: true,
            default: () => ''
        }
    },
    data: () => ({   
        pagination: {
            currentPage: 1,
            totalItemCount: 0,
            pageCount: 1,
            count: 0,
            pageSize: DEFAULT_PAGE_SIZE,
        },
        evaluations: [],
    }),
    async mounted(){
        await this.getHistoryList();
    },
    methods:{
        async getHistoryList() {
                                    
            const params = {
                studentSieId: this.studentSieId,       
                pageNumber: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,       
            };
            const { data: res } = await getHistory(params);

            this.evaluations =
                res.data.filter(
                (x) =>
                    !(
                    x.sourceId == evaluationSourceTypes.MiPE_Cita &&
                    (x.appointmentStatusId == appointmentStatusEnum.cancelled_Prov ||
                        x.appointmentStatusId == appointmentStatusEnum.cancelled_De)
                    )
                ) || [];    

            this.pagination = {
                ...this.pagination,
                currentPage: res.currentPage,
                count: res.count,
                pageCount: res.pageCount,
                totalItemCount: res.totalItemCount,
            };
        },
        async goToPage(page) {
            this.pagination.currentPage = page;
            await this.getHistoryList();
        },
    }
    
}
</script>

<style>

</style>